<template lang="html">
<div>
     <div class="c-body">
         <div class="list-ttl">专辑曲目列表</div>
         <div class="album-list">
              <div class="list-item" v-for="(item,index) in listDat"  :key="index" @click="goInner(item)">
                  <div class="item-x">{{item.side}}{{item.code}}</div>
                  <div class="item-content">
                       <div>
                           <div class="song-name">{{item.firstTitle}}</div>
                           <div class="song-text">
                                <span v-if="item.info">{{item.info | getClassify}} / {{item.info | getAuthors}}</span>
                                <span>{{item.info | getAuthors}}</span>
                           </div>
                       </div>
                  </div>
                  <div class="item-icons">
                        <van-icon class="icon" class-prefix="iconfont" name="play2" />
                  </div>
              </div>
         </div>
     </div>
</div>
</template>

<script>
export default {
    props:['listDat','albumId','account','pwd'],
    data(){
        return{
        }
    },
    filters:{
        getClassify:function(e){
            if(JSON.parse(e)['音乐分类']){
               let classArr = JSON.parse(e)['音乐分类'].split(",");
               return classArr[classArr.length - 1];
            }else{
               return '';
            }
        },
        getAuthors:function(e){
            let authors = JSON.parse(e)['演唱'] || JSON.parse(e)['演奏'] || JSON.parse(e)['地区'];
            if(typeof(authors)== 'string'){
                return authors[0]['显示'];
            }
        }
    },

    methods:{
        goInner:function(e){
            this.push({
                 path:'song',
                 query:{
                      iab:this.albumId,
                      icd:e.id,
                      account:this.account,
                      pwd:this.pwd
                 }
            })
        }
    },
    mounted() {
        // window.console.log(this.listDat);
    }
}
</script>

<style lang="css" scoped>

.list-ttl{
    font-weight: bold;
    margin: 0 10px;
    margin-top: 6px;
}

.list-item{
    display: flex;
    height: 72px;
    align-items: center;
}

.item-x{
    width: 36px;
    margin-left: 12px;
}

.song-text{
    font-size: 14px;
    color: #999999;
    letter-spacing: 0.72px;
    margin-top: 2px;
}

.item-content{
    flex-grow: 1;
    height: 72px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #efefef;
}

.item-icons{
    height: 72px;
    width: 45px;
    text-align: center;
    line-height: 72px;
    border-bottom: 1px solid #efefef;
}

.item-icons .icon{
  font-size: 24px;
  color: #999999;
}

</style>
